module.exports = __webpack_public_path__ + "static/media/161007-DSC05146-33_Small.f1490321.jpg";